"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowStatusCard = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const core_2 = require("@sierralabs/core");
const core_ui_1 = require("@sierralabs/core-ui");
const user_ui_1 = require("@sierralabs/user-ui");
const useGetStatusLogs_1 = require("../hooks/useGetStatusLogs");
const useWorkflowStatusLabel_1 = require("../hooks/useWorkflowStatusLabel");
const StyledTypography = (0, styled_components_1.default)(core_1.Typography) `
  font-weight: 500;
`;
const WorkflowStatusCard = props => {
    const { workflow } = props;
    const limit = 5;
    const workflowRef = (0, react_1.useRef)(workflow);
    const [page, setPage] = (0, react_1.useState)(0);
    const [logs, setLogs] = (0, react_1.useState)([]);
    const { statusLogList, isLoading, error, get } = (0, useGetStatusLogs_1.useGetStatusLogs)(workflow.id);
    const statusLabel = (0, useWorkflowStatusLabel_1.useWorkflowStatusLabel)(workflow.status);
    const getStatusLogsWithParams = (0, react_1.useCallback)(() => {
        get({ page, limit });
    }, [page, limit, get]);
    (0, react_1.useEffect)(() => {
        if (workflow !== workflowRef.current) {
            workflowRef.current = workflow;
            setLogs([]);
            // update page to 0, fetch if currently 0
            setPage(page => {
                page === 0 && getStatusLogsWithParams();
                return 0;
            });
        }
    }, [workflow, getStatusLogsWithParams]);
    (0, react_1.useEffect)(() => {
        getStatusLogsWithParams();
    }, [getStatusLogsWithParams]);
    (0, react_1.useEffect)(() => {
        if (!(statusLogList === null || statusLogList === void 0 ? void 0 : statusLogList.data)) {
            return;
        }
        setLogs(logs => {
            const newLogs = statusLogList.data.filter(newLog => !logs.some(log => log.id === newLog.id));
            // sort the list after appending statuses
            return logs.concat(newLogs).sort((a, b) => {
                return new Date(b.created).getTime() - new Date(a.created).getTime();
            });
        });
    }, [statusLogList]);
    return (react_1.default.createElement(core_1.Card, null,
        react_1.default.createElement(core_ui_1.CardContent, { background: 'primary' },
            react_1.default.createElement(core_1.Typography, { variant: 'overline', style: { margin: 0, paddingTop: 20 } }, "Status"),
            react_1.default.createElement(StyledTypography, { variant: 'h4' }, statusLabel)),
        react_1.default.createElement(core_1.TableContainer, null,
            react_1.default.createElement(core_1.Table, null,
                react_1.default.createElement(core_1.TableHead, null,
                    react_1.default.createElement(core_1.TableRow, null,
                        react_1.default.createElement(core_1.TableCell, null, "History"),
                        react_1.default.createElement(core_1.TableCell, null, "Version"),
                        react_1.default.createElement(core_1.TableCell, null, "Status"),
                        react_1.default.createElement(core_1.TableCell, null, "Employee"))),
                react_1.default.createElement(core_1.TableBody, null,
                    isLoading && (react_1.default.createElement(core_1.TableRow, null,
                        react_1.default.createElement(core_1.TableCell, { colSpan: 4, padding: 'none' },
                            react_1.default.createElement(core_1.LinearProgress, null)))),
                    error && (react_1.default.createElement(core_1.TableRow, null,
                        react_1.default.createElement(core_1.TableCell, { colSpan: 4, padding: 'none' },
                            react_1.default.createElement(lab_1.Alert, { severity: 'error' }, error.message)))), logs === null || logs === void 0 ? void 0 :
                    logs.map((log, index) => (react_1.default.createElement(core_1.TableRow, { key: index },
                        react_1.default.createElement(core_1.TableCell, null, (0, core_2.formatDate)(log.created)),
                        react_1.default.createElement(core_1.TableCell, null, log.version),
                        react_1.default.createElement(core_1.TableCell, null,
                            react_1.default.createElement(core_ui_1.StatusLabel, { status: log.status, className: log.status })),
                        react_1.default.createElement(core_1.TableCell, null,
                            react_1.default.createElement(user_ui_1.UserLink, { disableLink: true, user: log.createdBy })))))))),
        statusLogList && statusLogList.total > (page + 1) * limit && (react_1.default.createElement(core_1.Box, { textAlign: 'center', padding: 2 },
            react_1.default.createElement(core_1.Link, { variant: 'body2', component: 'button', onClick: () => setPage(page + 1) }, "Load More")))));
};
exports.WorkflowStatusCard = WorkflowStatusCard;
exports.default = exports.WorkflowStatusCard;
//# sourceMappingURL=WorkflowStatusCard.js.map